<template>
  <carousel class="homepage-carousel"
            :autoplay="true"
            :autoplayHoverPause="true"
            :perPage=1
            :paginationEnabled="false"
            :autoplayTimeout=5000
            :loop="true">
    <slide v-for="slide,key in slides" 
          :key="key" 
          class="slide"
          :style="{ background: 'url('+slide.src+') center center','background-size': 'cover' }"
          >
          <div class="container" v-if="slide.caption">
              <h2 class="slide__strapline">{{ slide.caption }}</h2>
          </div>  
    </slide>
  </carousel>
</template>

<script>
  import 'vue3-carousel/dist/carousel.css'
  import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

  export default {

    props: ['slides'],
    components: {
      Carousel,
      Slide,
      Pagination,
      Navigation,
    }
  }
</script>